export const API_URL = "https://api-analisador-documentos.ibrowse.cloud";